<div class="error-main">
  <img src="{{ showError?.img }}" alt="" width="350px" />

  <div class="text-error">{{ showError?.error }}</div>

  <div class="text-def">
    {{ showError?.def }}
  </div>

  <button
    type="button"
    class="rounded-pill go-back-button p-button-sm"
    (click)="navigateToHome()"
    pButton
  >
    Go to Dashboard
  </button>
</div>
